import tiles from './tiles/all';
import { setSavedData as _setSavedData } from './set-saved-data';

const _defaultLayout = '{"0":{"columns":{"6":{"colSpan":3,"rowSpan":2}},"sortOrder":0,"visible":true},"2":{"columns":{"6":{"colSpan":1,"rowSpan":2}},"sortOrder":2,"visible":true},"3":{"columns":{"6":{"colSpan":2,"rowSpan":1}},"sortOrder":3,"visible":false},"4":{"columns":{"6":{"colSpan":2,"rowSpan":2}},"sortOrder":9,"visible":false},"5":{"columns":{"6":{"colSpan":1,"rowSpan":2}},"sortOrder":3,"visible":true},"6":{"columns":{"6":{"colSpan":3,"rowSpan":2}},"sortOrder":5,"visible":true},"7":{"columns":{"6":{"colSpan":1,"rowSpan":1}},"sortOrder":2,"visible":true},"8":{"columns":{"6":{"colSpan":1,"rowSpan":1}},"sortOrder":1,"visible":true},"9":{"columns":{"6":{"colSpan":1,"rowSpan":1}},"sortOrder":4,"visible":true},"10":{"columns":{"6":{"colSpan":2,"rowSpan":2}},"sortOrder":8,"visible":false},"11":{"columns":{"6":{"colSpan":2,"rowSpan":2}},"sortOrder":11,"visible":false},"12":{"columns":{"6":{"colSpan":2,"rowSpan":2}},"sortOrder":12,"visible":false}}';
const $tileLayout = $("#tilelayout");
const savedTileLayout = $tileLayout.data('tile-layout') || JSON.parse(_defaultLayout);
let k_tileLayout;
let _columns = 0;
let _columnsTag;
let _tiles = [];
let _removedTiles = [];
let _unavailableTiles = [];
const _availableTiles = [{
    tileId: 0,
    saveData: {},
    colSpan: 3,
    rowSpan: 1,
    header: {
        text: "Pending Approvals"
    },
    bodyTemplate: function (dataItem) {
        dataItem.tileId = 0;
        return kendo.template($("#pending-approvals-template").html())(dataItem);
    }
}, {
    tileId: 3,
    saveData: {},
    colSpan: 2,
    rowSpan: 1,
    header: {
        text: "Sox Updates"
    },
    isAvailable: function () {
        let $template = $("#sox-chart-template");
        return $template.data('is-available')
    },
    bodyTemplate: function (dataItem) {
        dataItem.tileId = 3;
        return kendo.template($("#sox-chart-template").html())(dataItem);
    }
}, {
    tileId: 4,
    saveData: {},
    colSpan: 2,
    rowSpan: 2,
    header: {
        text: "Attachments"
    },
    bodyTemplate: function (dataItem) {
        dataItem.tileId = 4;
        return kendo.template($("#attachment-grid-template").html())(dataItem);
    }
}, {
    tileId: 6,
    saveData: {},
    colSpan: 2,
    rowSpan: 2,
    header: {
        text: "Action Items"
    },
    bodyTemplate: function (dataItem) {
        dataItem.tileId = 6;
        return kendo.template($("#action-item-grid-template").html())(dataItem);
    }
},
    {
        tileId: 8,
        saveData: {},
        colSpan: 2,
        rowSpan: 1,
        header: {
            text: "Favorite Reports"
        },
        bodyTemplate: function (dataItem) {
            dataItem.tileId = 8;
            return kendo.template($("#favorite-report-template").html())(dataItem);
        }
    }, {
        tileId: 9,
        saveData: {},
        visible: true,
        colSpan: 2,
        rowSpan: 1,
        header: {
            text: "My Projects"
        },
        bodyTemplate: function (dataItem) {
            dataItem.tileId = 9;
            return kendo.template($("#my-projects-templates").html())(dataItem);
        }
    }, {
        tileId: 10,
        saveData: {},
        visible: true,
        colSpan: 2,
        rowSpan: 2,
        header: {
            text: "My Expiring Certifications"
        },
        bodyTemplate: function (dataItem) {
            dataItem.tileId = 10;
            return kendo.template($("#sitedocs-certification-template").html())(dataItem);
        }
    }];

export default function () {
    loadTileLayout()
        .then(_ => tiles())
        .then(_ => removeTileEvent())
        .then(_ => restoreDefaultLayout())
        .then(_ => $.event.trigger("on:PageUpdate"));
}

const orderTiles = () => {
    setSavedData();
    populateTilesMenu();
    sortItems(_tiles);
    return _tiles;
}

const loadTileLayout = () => {
    return new Promise((resolve, reject) => {
        calculateColumns();
        k_tileLayout = $tileLayout.kendoTileLayout({
            containers: orderTiles(),
            columns: _columns,
            rowsHeight: 235,
            reorderable: true,
            resizable: true,
            resize: function (e) {
                kendo.resize(e.container, true);
                setSortOrder();
                saveTileFormat().then(_ => console.debug('save success'));
            },
            reorder: function (e) {
                setSortOrder();
                saveTileFormat().then(_ => console.debug('save success'));
            }
        }).data('kendoTileLayout');

        function createCharts() {
            let showLabels = $(document).width() > 677;

            $("#views-chart").kendoChart({
                dataSource: {
                    data: [
                        {value: 2000, date: new Date(2020, 2, 30)},
                        {value: 80000, date: new Date(2020, 3, 5)},
                        {value: 130000, date: new Date(2020, 3, 10)},
                        {value: 170000, date: new Date(2020, 3, 15)},
                        {value: 190000, date: new Date(2020, 3, 20)},
                        {value: 150000, date: new Date(2020, 3, 25)},
                        {value: 160000, date: new Date(2020, 3, 30)}]
                },
                legend: {
                    visible: false
                },
                seriesDefaults: {
                    type: "line",
                    style: "smooth",
                    markers: {
                        visible: false
                    }
                },
                series: [{
                    field: "value",
                    categoryField: "date",
                    color: "#00ab57"
                }],
                valueAxis: {
                    line: {
                        width: 0
                    },
                    labels: {
                        step: 2
                    },
                    min: 0,
                    max: 200000,
                },
                categoryAxis: {
                    baseUnit: "fit",
                    labels: {
                        rotation: "auto",
                        format: "{0:d MMMM}",
                        visible: showLabels
                    },
                    majorGridLines: {
                        visible: false
                    },
                    majorTicks: {
                        visible: false
                    }
                }
            });

            $("#visitors-chart").kendoChart({
                dataSource: {
                    data: [
                        {value: 70, type: "New", color: "#4884D9"},
                        {value: 30, type: "Returning", color: "#00b2ba"},
                        {value: 16, type: "Other", color: "#d3df4e"},
                    ]
                },
                series: [{
                    type: "donut",
                    field: "value",
                    categoryField: "type",
                    startAngle: 70,
                    holeSize: 30,
                }],
                legend: {
                    position: "bottom"
                }
            });

            kendo.resize($(".k-grid"));
        }

        $(document).ready(createCharts);
        $(document).bind("kendo:skinChange", createCharts);
        windowResizeEvent();

        resolve();
    });
}

const setSortOrder = () => {
    let items = k_tileLayout.items;
    let length = items.length
    for (let i = 0; i < length; i++) {
        let item = items[i];
        item.sortOrder = item.order;
    }
}

const sortItems = (items) => {
    items.sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
    });
}

const setSavedData = () => {
    const result = _setSavedData(_availableTiles, savedTileLayout, _columns);
    _tiles.push(...result.tiles);
    _removedTiles.push(...result.removedTiles);
    _unavailableTiles.push(...result.unavailableTiles);
}

const saveTileFormat = () => {
    let data = savedTileLayout
    let items = k_tileLayout.items;
    let allItems = items.concat(_removedTiles).concat(_unavailableTiles);
    for (let i = 0; i < allItems.length; i++) {
        let item = allItems[i];
        let savedData = savedTileLayout[item.tileId] || {columns: {}};
        savedData.sortOrder = isNaN(item.sortOrder) ? i : item.sortOrder;
        savedData.visible = item.visible;
        savedData.columns[_columns] = {
            colSpan: item.colSpan,
            rowSpan: item.rowSpan
        }

        data[item.tileId] = savedData;
    }
    return new Promise(resolve => {
        $.post('/Account/User/SaveUserPageLayout', {data: JSON.stringify(data)}, function () {
            resolve();
        });
    });
}

const windowResizeEvent = () => {
    $(window).on("resize", function () {
        calculateColumns();
    });
}

const calculateColumns = () => {
    let _oldColumns = _columns;
    _columns = Math.floor($tileLayout.width() / 300) || 1;
    _columnsTag = `columns${_columns}`;

    if (_oldColumns !== 0 && _oldColumns !== _columns) {
        reloadPage();
    }
}

const removeTileEvent = () => {
    let $removeButtons = $('.js-remove-tile');

    $removeButtons.click(function () {
        let _this = $(this);
        let tileId = _this.data('tile-id');
        //Find Tile
        let tileToRemove = _tiles.find(tile => tile.tileId === tileId);
        // Get Tile Index
        let tileRemoveIndex = _tiles.indexOf(tileToRemove);

        //Set Visibility to false
        tileToRemove.visible = false;
        //Add to Remove list
        _removedTiles.push(tileToRemove);
        //Remove from tiles
        _tiles.splice(tileRemoveIndex, 1);

        k_tileLayout.setOptions({containers: _tiles});
        saveTileFormat()
            .then(_ => reloadPage());
    })
}

const populateTilesMenu = () => {
    let $tilesMenu = $('.js-tiles-menu');
    let $tilesMenuContent = $('.js-tiles-menu-content');

    $tilesMenuContent.html('');
    // $tilesMenu.hide();

    $.each(_removedTiles, function (index, ele) {
        $tilesMenuContent.append(addTileOption(ele));
    })

    $tilesMenuContent.append(addRestoreOption());

    if (_removedTiles.length) {
        // $tilesMenu.show();
        addTileEvent();
    }
}

const addTileOption = (obj) => {
    return `<li><span class="icon-label">${obj.header.text}</span><span class="js-add-tile icon-parent" data-tile-id='${obj.tileId}'><span class="k-icon k-i-plus js-add-tile" ></span></span></li>`;
}

const addRestoreOption = () => {
    return `<li><span class="icon-label">Restore Default</span><span class="icon-parent"><span class="k-icon k-i-reset"></span></span></li>`;
}

const addTileEvent = () => {
    let $addTileButton = $('.js-add-tile');
    $addTileButton.unbind('click');
    $addTileButton.click(function () {
        let _this = $(this);
        let tileId = _this.data('tile-id');
        //Find Tile
        let tileToAdd = _removedTiles.find(tile => tile.tileId === tileId);
        // Get Tile Index
        let tileAddIndex = _tiles.indexOf(tileToAdd);

        if (tileToAdd) {
            //Set Visibility to true
            tileToAdd.visible = true;
            //Add to Tile list
            _tiles.push(tileToAdd);
            //Remove from tiles
            _removedTiles.splice(tileAddIndex, 1);

            k_tileLayout.setOptions({containers: _tiles});
            saveTileFormat()
                .then(_ => reloadPage());
        }
    });

}

const reloadPage = () => {
    setTimeout(function () {
        location.reload();
    }, 50)
}

export const restoreDefaultLayout = () => {
    let $restoreButton = $('.k-icon.k-i-reset').parent();
    $restoreButton.unbind('click');
    $restoreButton.bind('click', function () {
        $.post('/Account/User/SaveUserPageLayout', {data: _defaultLayout}, function () {
            reloadPage()
        });
    });
}